/**
 * 业务中的公共配置
 */

export default {
  baseUrl: '/wap', // base地址
  path: {
    // 埋点上报地址
    statUrl: 'https://stpc.vivo.com.cn/shop/flyHeart',
    // jovi物联首页
    iot: 'https://mshopact.vivo.com.cn/page/20180827',
    // 帐户中心地址
    passport: 'https://passport.vivo.com.cn/',
    // wap商城地址
    shopUrl:
      process.env.NODE_ENV === 'production'
        ? 'https://shop.vivo.com.cn/wap'
        : 'http://mvivoshop.vivo.com.cn:3000/wap',
    // vivo+商城地址
    shopPlusUrl: 'https://mall.vivo.com.cn/h5',
    // 图片路径
    imageHost: 'https://shopstatic.vivo.com.cn/vivoshop/',
    // 如何升级会员
    memberCenter: 'https://member.vivo.com.cn/wap/index?source=shangxiang',
    // vivocare
    service: 'https://www.vivo.com.cn/service/vivocare',
    // 静态资源地址
    shopFrontBaseUrl: process.env.NODE_ENV === 'development' ? '/' : 'https://shopstatic.vivo.com.cn/vivoshop/spawap/',
    shopKefu: 'https://kefu.vivo.com.cn/robot-vivo/mobileChat.html?f=mall&forVivoSpace=share.mp.qq.com/cgi/share.php'
  }
}
